<template>
  <p-vue-dialog
    :showHeader="false"
    rtl
    modal
    dismissableMask
    id="open-service-call-success"
    :style="{
      maxHeight: '100%',
      width: '100%',
      maxWidth: 'calc(100vw - 10px) !important',
    }"
    :visible="localShow"
  >
    <div class="success__wrapper">
      <div class="success__content">
        <img
          v-if="isSuccess"
          class="success-icon"
          :src="require('@/assets/img/success.png')"
        />
        <i v-else class="pi pi-exclamation-circle"></i>
        <p
          class="success-message"
          :style="{
            color: isSuccess ? 'var(--color-success)' : 'var(--color-danger)',
          }"
        >
          {{ message }}
        </p>
      </div>
    </div>
    <p-vue-button
      v-if="showCloseBtn"
      class="p-button-secondary p-button-rounded p-d-flex p-m-auto p-px-5"
      @click="close"
    >
      {{ __("Close") }}
    </p-vue-button>
  </p-vue-dialog>
</template>

<script>
import { ref } from "vue";

export default {
  props: {
    message: String,
    timeout: {
      type: Number,
      default: 2000,
    },
    isSuccess: {
      type: Boolean,
      default: true,
    },
    close: {
      type: Function,
      default: () => false,
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const localShow = ref(true);

    setTimeout(() => (localShow.value = false), props.timeout);

    return {
      localShow,
    };
  },
};
</script>

<style scoped>
.success__wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: calc(100vw - 50px);
  height: calc(100vh - 90px);
}

.success-icon {
  max-width: 100%;

  transform: translateX(17px);
}

.success-message {
  margin: 0;

  font-size: 24px;
  line-height: 1.83;
  font-weight: bold;
  text-align: center;

  margin-top: -45px;
}

.success__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

:deep(.pi-exclamation-circle) {
  font-size: 150px;
  color: var(--color-danger);
  margin-bottom: 80px;
}
</style>
